"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Generates a unique hash for a passed string.
 * @param {string} s
 * @returns {string} hashed key
 */
function generateHash(s) {
    let a = 1;
    let c = 0;
    let h;
    let o;
    if (s) {
        a = 0;
        // eslint-disable-next-line no-loops/no-loops
        for (h = s.length - 1; h >= 0; h--) {
            o = s.charCodeAt(h);
            a = ((a << 6) & 268435455) + o + (o << 14);
            c = a & 266338304;
            a = c !== 0 ? a ^ (c >> 21) : a;
        }
    }
    return String(a);
}
exports.default = generateHash;
